import { Component, OnInit, ViewChild, ElementRef, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { FormBuilder, FormGroup, FormControl, Validators, FormsModule } from '@angular/forms';
import { LazyLoadEvent, MenuItem } from 'primeng/api';
import { QuestionService } from 'src/app/manage/questionanswer/service/question.service';
import { UserContestService } from 'src/app/services/usercontest.service';
import * as moment from 'moment';
import { ContestService } from 'src/app/services/contest.service';
import { environment } from 'src/environments/environment';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { CustomValidators } from 'ng2-validation';
import { AuthService } from 'src/app/services/auth.service';
import { MustMatch } from 'src/app/_helpers/must-match.validator';
import { RoleService } from 'src/app/services/role.service';
import { HttpClient } from '@angular/common/http';
import { maxYearFunction } from 'src/app/_helpers/utility';
import { HeaderComponent } from '../header/header.component';
import { CityService } from 'src/app/manage/city/service/city.service';
import { UserService } from 'src/app/services/user.service';
import { CountryService } from 'src/app/manage/country/service/country.service';
import { StateService } from 'src/app/manage/state/service/state.service';
import { WindowRefService } from 'src/app/services/window-ref.service';
import { WalletpaymentService } from 'src/app/services/walletPayments.service';
import { UserWalletService } from 'src/app/services/userWallet.service';
@Component({
  selector: 'app-contest-history',
  templateUrl: './contest-history.component.html',
  styleUrls: ['./contest-history.component.scss'],
  providers: [HeaderComponent, MessageService, ConfirmationService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContestHistoryComponent implements OnInit {
  totalEntries: boolean;
  items: MenuItem[];
  priceStructurePopup: boolean = false;
  public contestTotalRecords = 0;
  public options;
  public loading: boolean;
  public errorMessage: string;
  public totalRecords = 0;
  public contestList: any[] = [];
  public checkedBoxes: any[] = [];
  public attemptedQuestions: any[] = [];
  public resultList: any[] = [];
  public currentIndex: number = 0;
  public selectedOption: any = null;
  public currentQuestion;
  public answerString;
  public showSubmitButton: boolean = false;
  public downloadFlg: boolean = false;
  public showResult: boolean = false;
  public totalMarks: number = 0;
  public questionMarksTotal: number = 0;
  public rejoincontestList: any[] = [];
  public totalRecordsForRejoin = 0;
  carouselResponsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 12,
      numScroll: 12,
      margin: 20,
    },
    {
      breakpoint: '768px',
      numVisible: 2,
      numScroll: 2,
      margin: 20,
    },
    {
      breakpoint: '560px',
      numVisible: 1,
      numScroll: 1
    }
  ];
  @ViewChild('prevButton') prevButton: ElementRef;
  @ViewChild('nextButton') nextButton: ElementRef;
  lazyLoadEvent1: LazyLoadEvent;
  lazyLoadEvent2: LazyLoadEvent;
  searchby: any;
  startDate: any;
  endDate: any;
  public pagination = environment.pagination;
  public mode = "";
  loggedInUser: any;
  isLoggedIn: boolean = false;
  loginRegisterModal: boolean = false;
  showMobileLoginOtpForm: boolean = false;
  signUpForm: FormGroup;
  loginForm: FormGroup;
  forgotPassForm: FormGroup;
  mobileLoginForm: FormGroup;
  balanceForm: FormGroup;
  addCashForm: FormGroup;
  submitted: boolean = false;
  loginFormSubmitted: boolean = false;
  genders;
  message;
  showMessage: boolean = false;
  selectedGender: any = null;
  userType;
  userData;
  isLoginFailed: boolean;
  roles;
  trainerRoleId;
  permissions: any[] = [];
  permissionArray: any[] = [];
  userTypeListArray: any[] = [];
  rolelist: any[] = [];
  ipAddress;
  yearRange;
  minDateValue: Date;
  minYear = environment.minYear;
  showGenderError;
  public cityList: any[] = [];
  public selectedCityId;
  public selectedCityName;
  public mobileNumber;
  public showOtpForm: boolean = false;
  public successMessage;
  public activeIndex: number = 0;
  public showCategoryError: boolean = false;
  public letsPlayButtonDisabled: boolean = false;
  public addCoinModal: boolean = false;
  public totalAvailableCash;
  @ViewChild('ngOtpInput', { static: false }) ngOtpInput: any;
  public config = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,
    required: true,
    placeholder: '',
    inputStyles: {
      'width': '50px',
      'height': '50px'
    }
  };
  public otp: string;
  public showForgotPasswordForm: boolean = false;
  public showOtpErrors: boolean = false;
  public showOtpErrorsMsg: boolean = false;
  public showResendButton: boolean = false;
  public showMobileFormErrors: boolean = false;
  public mobileFormsErrors: boolean = false;
  public otpLoginErrors: boolean = false;
  public showOtpLoginErrors: boolean = false;
  public otpErrorMessage;
  public displayTime;
  public userCategories: any[] = [];
  public countrylist: any[] = [];
  public selectedCategory = undefined;
  public stateList: any[] = [];
  public countryName;
  public countryCode;
  public stateName;
  public stateCode;
  public cityName;
  public cityCode;
  public selectedType = undefined;
  public tplCoin: Number;
  public tplCash: Number;
  public showBalanceModal: boolean = false;
  public showBalanceCoinsError: boolean = false;
  public showBalanceCashError: boolean = false;
  public showAddCashModal: boolean = false;
  public tplCashCoinArr: any = [];
  public poolCash;
  public poolCoins;
  public cashFormSubmitted: boolean = false;
  public balanceFormSubmitted: boolean = false;
  public cashBalance: number = 0;
  public coinBalance: number = 0;
  public showCashBalance: boolean = false;
  public showCoinBalance: boolean = false;
  public showCashError: boolean = false;
  public showContestDetailSection: boolean = false;
  public userId;
  public contestId: any;
  public showPaymentSelectionError: boolean = false;
  public contest;
  public termsAndConditionsCheck: boolean = false;
  public dontShowAgainCheck: boolean = false;
  public showTermsAndConditionError: boolean = false;
  public showDontShowAgainError: boolean = false;
  showThankyouModal: boolean;
  totalCash: any;
  totalCoins: any;
  public addCoinForm: FormGroup;
  public coinSubmitted;
  pricePoolStructurePopup: boolean;
  twoToFour: boolean;
  fiveToSeven: boolean;
  sevenToTen: boolean;
  eightToTen: boolean;
  eightToTwelve: boolean;
  fourteenToEighteen: boolean;
  nineteenToTwentySeven: boolean;
  twentyEightToThirtySix: boolean;
  thirtySevenToFifty: boolean;
  fiftyOnePlus: boolean;
  thirteenToEighteen: boolean;
  elevenToThirteen: boolean;
  pageNumberFirst: any;
  pageLimitFirst: any;
  activeTab: any;
  onContestTabChange: boolean = false;
  totalAllContestRecords: any = 0;
  constructor(private questionService: QuestionService,
    private userContestService: UserContestService,
    private contestService: ContestService,
    private router: Router,
    private formBuilder: FormBuilder,
    private roleService: RoleService,
    private http: HttpClient,
    private headerComponent: HeaderComponent,
    private cityService: CityService,
    private userService: UserService,
    private countryService: CountryService,
    private stateService: StateService,
    private tokenStorage: TokenStorageService,
    private authService: AuthService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private winRef: WindowRefService,
    private walletPaymentService: WalletpaymentService,
    private userWalletService: UserWalletService,
    private changeDetectorRef: ChangeDetectorRef,
  ) { }
  async ngOnInit(): Promise<void> {
    this.roleService.setCurrentActiveRoute(this.router.url);
    this.loggedInUser = this.tokenStorage.getUser();
    if (this.loggedInUser.userdata != undefined) {
      this.userId = this.loggedInUser.userdata.id;
      this.isLoggedIn = true;
      //this.getUserContest();
    }
    this.activeIndex = Number(0);
    await this.loadContest(this.lazyLoadEvent1, this.mode)
    await this.loadContestForRejoin(this.lazyLoadEvent2, this.mode)
    this.items = [
      { routerLink: "/", label: "Home" },
      { label: "Club Leagues" }
    ];
    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email, CustomValidators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]],
    });
    this.balanceForm = this.formBuilder.group({
    });
    this.addCashForm = this.formBuilder.group({
      cash: [null, [Validators.required]],
    });
    this.addCoinForm = this.formBuilder.group({
      amount: ['', [Validators.required, CustomValidators.number]],
    });
    // this.signUpForm = this.formBuilder.group({
    //   firstName: ['', [Validators.required, Validators.pattern('[A-Za-z][A-Za-z]*$')]],
    //   lastName: ['', [Validators.required, Validators.pattern('[A-Za-z][A-Za-z]*$')]],
    //   email: ['', [Validators.required, Validators.email, CustomValidators.email]],
    //   password: ['', [Validators.required, Validators.pattern("^(?=[^A-Z\n]*[A-Z])(?=[^a-z\n]*[a-z])(?=[^0-9\n]*[0-9])(?=[^#?!@$%^&*\n-]*[#?!@$%^&*-]).{6,}$")]],
    //   confirmPassword: ['', Validators.required],
    //   mobileNumber: [null, [Validators.required, Validators.pattern("[0-9 ]{10}")]],
    //   country: ['', [Validators.required]],
    //   state: ['', [Validators.required]],
    //   city: ['', [Validators.required]],
    //   gender: [''],
    //   //role: ['player'],
    //   //userType: ['player']
    // }, {
    //   validator: MustMatch('password', 'confirmPassword')
    // });
    this.userCategories.forEach(element => {
      this.signUpForm.addControl(element.slug, new FormControl());
      if (element.slug == "player") {
        this.selectedCategory = element.slug;
        this.signUpForm.get(element.slug).setValue(element.status);
      }
    });
    this.forgotPassForm = new FormGroup({
      email: new FormControl("", [Validators.required, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,3}")])
    });
    this.mobileLoginForm = this.formBuilder.group({
      mobileNumber: [null, [Validators.required, Validators.pattern("[0-9 ]{10}")]],
    });
    this.genders = [
      { id: '1', name: 'Male', code: 'Male' },
      { id: '2', name: 'Female', code: 'Female' },
      { id: '3', name: 'Other', code: 'Other' },
    ];
    this.selectedGender = this.genders[0];
    this.getCountries();
    const paginationData = JSON.parse(window.localStorage.getItem('my-contest-pagination'));
    this.pageNumberFirst = paginationData['page'];
    this.pageLimitFirst = paginationData['limit'];
    this.activeIndex = paginationData['tab'];

    this.router.events.subscribe((events)=>{
      if(events instanceof NavigationEnd) {
        if(!(events.url.includes('/contest-history') || events.url.includes('/contest-leader-board') || events.url.includes('/contest-details'))) {
          let initialMyContestPaginationvalues = { page: 1, limit: 10, tab: 0 };
          window.localStorage.setItem('my-contest-pagination',JSON.stringify(initialMyContestPaginationvalues));
        }
      }
    })
  }
  // convenience getter for easy access to form fields
  get f() {
    return this.signUpForm.controls;
  }
  get loginf() {
    return this.loginForm.controls;
  }
  get forgotPassValidation() {
    return this.forgotPassForm.controls;
  }
  get mobNumberFormValidation() {
    return this.mobileLoginForm.controls;
  }
  get cashFormValidation() {
    return this.addCashForm.controls;
  }
  get f1() {
    return this.addCoinForm.controls;
  }
  // getUserContest() {
  //   let query = "filterByDisable=false&filterByStatus=true&filterByUserId=" + this.userId;
  //   this.userContestService.getUserContestList(query).subscribe(
  //     data => {
  //     },
  //     err => {
  //     }
  //   );
  // }
  async loadContest(event: LazyLoadEvent, mode) {
    this.lazyLoadEvent1 = event;
    const contestTabs = ['All Contest','Resume Contest'];
    let pagenumber = 1;
    let params = "";
    let rows = 10;
    let query = "filterByDisable=false&filterByStatus=true&filterByisContestRegistrationComplete=true&filterByUserId=" + this.userId;
    if (event !== undefined && !this.onContestTabChange) {
      if (event.first != undefined && event.first == 0) {
        pagenumber = event.first + 1;
      } else if (event.first != undefined && event.first > 0) {
        pagenumber = (event.first / event.rows) + 1;
      } else {
        pagenumber = 1;
      }
      if (event.rows != undefined) {
        rows = event.rows;
      } else {
        rows = 10;
      }
      if(contestTabs[this.activeIndex] === 'All Contest') {
        let contestHistoryPaginationValues = { page: pagenumber, limit: rows, tab: this.activeIndex }
        window.localStorage.setItem('my-contest-pagination',JSON.stringify(contestHistoryPaginationValues));
      }
    }

    if(event === undefined || contestTabs[this.activeIndex] !== 'All Contest') {
      const paginationData = JSON.parse(window.localStorage.getItem('my-contest-pagination'));
      pagenumber = paginationData['page'];
      rows = paginationData['limit'];
      this.activeIndex = paginationData['tab'];
    }
    this.pageNumberFirst = pagenumber;
    this.pageLimitFirst = rows; 
    query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
    
    this.userContestService.getUserContestList(query).subscribe(
      data => {
        window.scroll(0, 0);
        this.loading = false;
        this.totalAllContestRecords = data.data.totalCount;
        this.contestTotalRecords = data.data.totalCount;
        this.changeDetectorRef.detectChanges();
        data.data.items?.forEach(cElement => {
          let tournamentstr = cElement.tournamentName;          
          if(cElement.tournamentName != undefined){
            let tournamentarr = tournamentstr.split(",");
            if(tournamentarr.length > 0) {
              cElement.displaytournamentName = tournamentarr[0];
            } else {
              cElement.displaytournamentName = tournamentstr;
            }
          } else {
            cElement.displaytournamentName = tournamentstr;
          }});
          this.contestList = data.data.items;
      },
      err => {
        this.errorMessage = err.error.message;
      });
      this.onContestTabChange = false;
  }
  findIndexById(id, arrayName) {
    let index = -1;
    for (let i = 0; i < arrayName.length; i++) {
      if (arrayName[i].id === id) {
        index = i;
        break;
      }
    }
    return index;
  }
  getCountries() {
    let query = "filterByDisable=false&filterByStatus=true";
    this.countryService.getcountryList(query).subscribe(
      data => {
        if (data.data.items.length > 0) {
          data.data.items.forEach(element => {
            let countryObj = {
              name: element.name,
              iso2: element.iso2,
            }
            this.countrylist.push(countryObj);
          });
        }
      },
      err => {
        this.errorMessage = err.error.message;
      }
    );
  }
  getStates(event) {
    this.countryName = event.value.name;
    this.countryCode = event.value.iso2;
    let query = "filterByDisable=false&orderBy=name&sortBy=1&filterByCountryCode=" + this.countryCode;
    this.stateService.getstateList(query).subscribe((res) => {
      if (res.data.items.length > 0) {
        res.data.items.forEach(element => {
          let stateObj = {
            name: element.name,
            id: element.id,
          }
          this.stateList.push(stateObj);
        });
      }
    })
  }
  setState(event) {
    this.stateCode = event.value.id;
    this.stateName = event.value.name;
    this.getCities(this.stateCode);
  }
  getCities(stateId) {
    let query = "?filterByStatus=true&filterByDisable=false&orderBy=name&sortBy=1&filterByStateId=" + stateId;
    this.cityService.getcityList(query).subscribe((res) => {
      if (res.data.items.length > 0) {
        res.data.items.forEach(element => {
          let cityObj = {
            name: element.name,
            code: element.name,
          }
          this.cityList.push(cityObj);
        });
      }
    })
  }
  // onCitySelect(event) {
  //   this.cityCode = event.value.code;
  //   this.cityName = event.value.name;
  // }
  getRoleDetails() {
    const querystring = "filterByroleId=" + this.userData.data.userdata.role;
    this.roleService.searchRoleDetails(querystring).subscribe(
      data => {
        this.trainerRoleId = data.data.items[0]['id'];
        this.permissions = data.data.items[0]['permissions'];
        this.tokenStorage.saveUserPermissions(this.permissions);
        this.rolelist = data.data.items[0];
      },
      err => {
        this.errorMessage = err.error.message;
      }
    );
  }
  findIndexByIdArray(name, arrayName) {
    let index = -1;
    for (let i = 0; i < arrayName.length; i++) {
      if (arrayName[i].rolename === name) {
        index = i;
        break;
      }
    }
    return index;
  }
  getRoleList() {
    var querystring = "filterByDisable=false&filterByStatus=true";
    var rolearray = [];
    this.roleService.getRoleList(querystring).subscribe(
      data => {
        var rolelist = data.data.items;
        rolelist.forEach(element => {
          rolearray.push({ "roleid": element.id, "rolename": element.user_role_name });
        });
        if (rolearray.length > 0) {
          this.tokenStorage.saveRolelist(rolearray);
        }
      },
      err => {
        this.errorMessage = err.error.message;
      }
    );
  }
  onUserCategorySelect(userCategory, event) {
    this.selectedCategory = undefined;
    if (event.isTrusted) {
      this.selectedCategory = userCategory.slug;
      this.userCategories.forEach(element => {
        let obj = { slug: element.slug, name: element.name, status: element.status };
        if (this.selectedCategory == element.slug) {
          const index = this.findIndexBySlug(element.slug, this.userCategories);
          obj = { slug: element.slug, name: element.name, status: true };
          this.userCategories[index] = obj;
          this.signUpForm.get(element.slug).setValue(obj.status);
        } else {
          const index = this.findIndexBySlug(element.slug, this.userCategories);
          obj = { slug: element.slug, name: element.name, status: false };
          this.userCategories[index] = obj;
          //this.accountReportForm.get(element.name).setValue(reportObj);
        }
      })
    }
  }
  findIndexBySlug(slug, arrayName) {
    let index = -1;
    for (let i = 0; i < arrayName.length; i++) {
      if (arrayName[i].slug === slug) {
        index = i;
        break;
      }
    }
    return index;
  }
  onSubmit(): void {
    this.loginFormSubmitted = true;
    //stop here if form is invalid
    if (this.loginForm.invalid) {
      return;
    }
    const username = this.loginForm.value.email;
    const password = this.loginForm.value.password;
    this.userType = "player";
    this.authService.login(username, password, this.userType, false).subscribe(
      data => {
        this.userData = data;
        this.tokenStorage.saveToken(this.userData.data.access_token);
        this.tokenStorage.saveUser(this.userData.data);
        this.tokenStorage.getAuthStatus(this.userData.data);
        this.isLoginFailed = false;
        this.isLoggedIn = true;
        this.roles = this.tokenStorage.getUser().roles;
        this.getRoleDetails();
        this.getRoleList();
        this.loginRegisterModal = false;
        let currentUrl = '/contest-history';
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate([currentUrl]);
        //this.onClickJoin(this.contest-history);
      },
      error => {
        //throw Error();
        this.loginFormSubmitted = false;
        this.errorMessage = 'Login failed: Please check your login credentials...! ';
        let currentUrl = '/sign-in';
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate([currentUrl]);
        this.isLoginFailed = true;
      }
    );
    //});
  }
  onSignupSubmit(): void {
    this.submitted = true;
    //stop here if form is invalid
    if (this.signUpForm.invalid) {
      return;
    }
    let userData = this.signUpForm.value;
    if (this.selectedGender == null) {
      this.showGenderError = true;
      return;
    }
    if (this.selectedCategory == undefined) {
      this.showCategoryError = true;
      return;
    }
    userData['gender'] = this.selectedGender;
    userData['citycode'] = this.selectedCityId;
    userData['cityname'] = this.selectedCityName;
    userData['role'] = this.selectedCategory;
    userData['userType'] = this.selectedCategory;
    this.mobileNumber = userData['mobileNumber'];
    delete userData['coach'];
    delete userData['player'];
    this.authService.playerSignup(userData).subscribe(
      data => {
        //this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'User Added', life: 6000 });
        // setTimeout(() => {
        this.showMessage = true;
        this.showOtpForm = true;
        this.submitted = false;
        //this.message = 'User Added';
        setTimeout(() => {
          this.showMessage = false;
        }, 5000);
        this.signUpForm.reset();
        // this.userTypeError = false;
        //this.selectedGender = this.genders[0];
        //this.router.navigateByUrl("/sign-in");
        //}, 5000);
      },
      ((err) => {
        this.showMessage = true;
        this.message = err.error.error;
        setTimeout(() => {
          this.showMessage = false;
        }, 5000);
        //this.messageService.add({ key: 'toastmsg', severity: 'error', summary: err.error.message, detail: 'Add User Failed', life: 6000 });
      })
    );
  }
  onOtpChange(otp) {
    this.otp = otp;
  }
  onClickOtpSubmit() {
    if (this.otp == undefined || this.otp.length < 6) {
      this.showOtpErrors = true;
      return;
    }
    let otpData = {
      'otp': this.otp,
      'mobileNumber': this.mobileNumber,
    }
    this.authService.verifyOtp(otpData).subscribe(
      data => {
        // setTimeout(() => {
        this.showMessage = true;
        this.signUpForm.reset();
        this.submitted = false;
        this.showOtpForm = false;
        this.showOtpErrors = false;
        this.activeIndex = Number(0);
        //this.message = 'User Added';
        setTimeout(() => {
          this.showMessage = false;
        }, 5000);
      },
      ((err) => {
        this.showOtpErrorsMsg = true;
        this.otpErrorMessage = err.error.error;
        setTimeout(() => {
          this.showOtpErrorsMsg = false;
        }, 5000);
      })
    );
  }
  onClickForgotPassword() {
    this.showForgotPasswordForm = true;
  }
  onForgotPassSubmit() {
    this.submitted = true;
    if (this.forgotPassForm.valid) {
      this.authService.requestPassword(this.forgotPassForm.value).subscribe(res => {
        if (res['errors']) {
          this.errorMessage = res['errors'];
          this.successMessage = '';
        } else {
          this.successMessage = res;
          this.errorMessage = '';
        }
        this.showMessage = true;
        setTimeout(() => {
          this.submitted = false;
          this.forgotPassForm.reset();
          this.showMessage = false;
          this.successMessage = '';
        }, 2000);
      },
        err => {
          this.successMessage = '';
          this.showMessage = true;
          this.errorMessage = err.error.data.errors;
        });
    }
  }
  onMobilePhoneSubmit(mode) {
    let mobileData;
    if (mode != "resend") {
      this.submitted = true;
      //stop here if form is invalid
      if (this.mobileLoginForm.invalid) {
        return;
      }
      mobileData = this.mobileLoginForm.value.mobileNumber;
      this.mobileNumber = mobileData;
    } else {
      mobileData = this.mobileNumber
    }
    this.authService.generateMobileOtp(mobileData).subscribe(
      res => {
        this.showMobileLoginOtpForm = true;
        this.showResendButton = false;
        this.timer(1);
      }, err => {
        this.showMobileFormErrors = true;
        this.mobileFormsErrors = err.error.error;
        setTimeout(() => {
          this.showMobileFormErrors = false;
        }, 2000);
        this.showMobileLoginOtpForm = false;
      });
  }
  resendOtp() {
    let mode = 'resend';
    this.onMobilePhoneSubmit(mode);
  }
  onClickOtpLoginSubmit() {
    if (this.otp == undefined || this.otp.length < 6) {
      this.showOtpErrors = true;
      return;
    }
    let otpData = {
      'otp': this.otp,
      'mobileNumber': this.mobileNumber,
    }
    this.authService.otpLogin(otpData).subscribe(
      data => {
        this.userData = data;
        this.tokenStorage.saveToken(this.userData.data.access_token);
        this.tokenStorage.saveUser(this.userData.data);
        this.tokenStorage.getAuthStatus(this.userData.data);
        this.isLoggedIn = true;
        this.roles = this.tokenStorage.getUser().roles;
        this.getRoleDetails();
        this.getRoleList();
        // let currentUrl = '/';
        // this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        // this.router.onSameUrlNavigation = 'reload';
        // this.router.navigate([currentUrl]);
      },
      ((err) => {
        this.showOtpLoginErrors = true;
        this.otpLoginErrors = err.error.error;
        setTimeout(() => {
          this.showOtpLoginErrors = false;
        }, 2000);
      })
    );
  }
  timer(minute) {
    // let minute = 1;
    let seconds: number = minute * 60;
    let textSec: any = "0";
    let statSec: number = 60;
    const prefix = minute < 10 ? "0" : "";
    const timer = setInterval(() => {
      seconds--;
      if (statSec != 0) statSec--;
      else statSec = 59;
      if (statSec < 10) {
        textSec = "0" + statSec;
      } else textSec = statSec;
      this.displayTime = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;
      if (seconds == 0) {
        clearInterval(timer);
        this.showResendButton = true;
      }
    }, 1000);
  }
  onForgotPassBack() {
    this.showForgotPasswordForm = false;
  }
  onTermsAndConditionsSelect(event) {
    if (event.checked) {
      this.termsAndConditionsCheck = true;
    } else {
      this.termsAndConditionsCheck = false;
    }
  }
  onDontShowAgainSelect(event) {
    if (event.checked) {
      this.dontShowAgainCheck = true;
    } else {
      this.dontShowAgainCheck = false;
    }
  }
  async onClickSubmit() {
    if (this.termsAndConditionsCheck == false) {
      this.showTermsAndConditionError = true;
      return;
    }
    this.showContestDetailSection = false;
    var query = "?filterByDisable=false&filterByUserid=" + this.userId;
    this.userWalletService.getUserWalletList(query).subscribe(
      data => {
        this.loading = false;
        this.totalCash = data.data.totalCash;
        this.totalCoins = data.data.totalCoins;
        this.tplCash = this.totalCash;
        this.tplCoin = this.totalCoins;
        this.tplCashCoinArr = [
          {
            slug: "cash",
            coinsOrCash: this.tplCash,
            name: 'Cash',
            status: true
          },
          {
            slug: "coins",
            coinsOrCash: this.tplCoin,
            name: "Coins",
            status: false
          }
        ];
        this.tplCashCoinArr.forEach(element => {
          this.balanceForm.addControl(element.slug, new FormControl());
        });
        this.showBalanceModal = true;
      },
      err => {
        this.errorMessage = err.error.message;
      });
  }
  onClickJoin(contest) {
    this.contest = contest;
    if (this.isLoggedIn == false) {
      this.loginRegisterModal = true;
    } else {
      this.showContestDetailSection = true;
      this.contestId = contest.id
      this.poolCoins = contest.poolCoins;
      this.poolCash = Number(contest.poolCoins) / Number(10);
    }
  }
  onTplCashOrCoinSelect(tplCashOrCoin, event) {
    this.selectedType = tplCashOrCoin.slug;
    this.showPaymentSelectionError = undefined;
    if (this.selectedType == 'cash') {
      this.cashBalance = Number(this.tplCash) - Number(this.poolCash);
      this.showCashBalance = true;
      this.showCoinBalance = false;
    }
    if (this.selectedType == 'coins') {
      this.coinBalance = Number(this.tplCoin) - Number(this.poolCoins);
      this.showCashBalance = false;
      this.showCoinBalance = true;
    }
    this.tplCashCoinArr.forEach(element => {
      let obj = { slug: element.slug, name: element.name, coinsOrCash: element.coinsOrCash, status: element.status };
      if (this.selectedType == element.slug) {
        const index = this.findIndexBySlug(element.slug, this.tplCashCoinArr);
        if (index != -1) {
          obj = { slug: element.slug, name: element.name, coinsOrCash: element.coinsOrCash, status: true };
          this.tplCashCoinArr[index] = obj;
          this.balanceForm.get(element.slug).setValue(obj.status);
        }
      } else {
        const index = this.findIndexBySlug(element.slug, this.tplCashCoinArr);
        if (index != -1) {
          obj = { slug: element.slug, name: element.name, coinsOrCash: element.coinsOrCash, status: false };
          this.tplCashCoinArr[index] = obj;
        }
      }
    });
  }
  onClickAddCash() {
    this.showAddCashModal = true;
    this.showBalanceModal = false;
  }
  onCashSubmit() {
    this.cashFormSubmitted = true;
    //stop here if form is invalid
    if (this.addCashForm.invalid) {
      return;
    }
    let cashData = this.addCashForm.value;
    let cash = cashData['cash'];
    cashData['userId'] = this.userId;
    if (Number(cash) < Number(100)) {
      this.showCashError = true;
      return;
    } else {
      this.showCashError = false;
    }
    var addCashData = this.addCashForm.value;
    addCashData['userId'] = this.userId;
    addCashData['amount'] = addCashData.cash;
    if (addCashData['amount'] > 0) {
      this.showAddCashModal = false;
      addCashData = JSON.stringify(addCashData, null, 4);
      const amt = addCashData['amount'];
      this.walletPaymentService.addWalletPayment(addCashData).subscribe(data => {
        let options: any = {
          key: environment.RAZORPAY_KEY_ID,
          amount: this.addCashForm.value.amount * 100, // amount should be in paise format to display Rs 1255 without decimal point
          currency: 'INR',
          name: 'TPL', // company name or product name
          description: 'User Added Cash to wallet',  // product description
          image: '../../../../assets/images/logo.png', // company logo or product image
          order_id: data.data['orderId'], // user_id created by you in backend
          modal: {
            // We should prevent closing of the form when esc key is pressed.
            escape: false,
          },
          notes: {
            // include notes if any
          },
          theme: {
            color: '#0c238a'
          }
        };
        options.handler = ((response, error) => {
          options.response = response;
          let verifyPaymentData = {
            'razorpay_payment_id': response.razorpay_payment_id,
            'razorpay_order_id': response.razorpay_order_id,
            'razorpay_signature': response.razorpay_signature,
            'userId': this.userId,
            'walletType': 'CASH',
            'amount': this.addCashForm.value.amount
          };
          // call your backend api to verify payment signature & capture transaction
          this.walletPaymentService.verifyWalletpayment(verifyPaymentData).subscribe(paymentdata => {
            this.showThankyouModal = true;
          })
        });
        options.modal.ondismiss = (() => {
          // handle the case when user closes the form while transaction is in progress
          console.log('Transaction cancelled.');
        });
        const rzp = new this.winRef.nativeWindow.Razorpay(options);
        rzp.open();
        return;
      });
    }
  }
  onClickLetsPlay() {
    this.balanceFormSubmitted = true;
    //stop here if form is invalid
    if (this.balanceForm.invalid) {
      return;
    }
    if (this.selectedType == undefined) {
      this.showPaymentSelectionError = true;
      return;
    }
    let cash = 0;
    let coins = 0;
    if (this.selectedType == "cash") {
      if (Number(this.poolCash) > Number(this.tplCash)) {
        this.showBalanceCashError = true;
        return;
      }
      cash = this.poolCash;
    }
    if (this.selectedType == "coins") {
      if (Number(this.poolCoins) > Number(this.tplCoin)) {
        this.showBalanceCoinsError = true;
        return;
      }
      coins = this.poolCoins;
    }
    let userWalletData = {
      contestId: this.contestId,
      userId: this.userId,
      amount: cash,
      wallettype: 'CASH',
      action: 'SUBTRACT',
      status: true,
      description: "Contest Joined",
    }
    this.userWalletService.addUserWallet(userWalletData).subscribe(
      async data => {
        await this.addContest(cash, coins);
      },
      err => {
        this.messageService.add({ key: 'toastmsg', severity: 'error', summary: 'Error', detail: 'Server error, please try again.', life: 6000 });
      }
    );
  }
  async addContest(cash, coins) {
    let userContestData =
    {
      cash: cash,
      coins: coins,
      contestId: this.contestId,
      userId: this.userId,
    }
    this.userContestService.addUserContest(userContestData).subscribe(
      data => {
        this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Contest Joined Successfully!!', life: 6000 });
        setTimeout(() => {
          let currentUrl = '/contest-history-details/' + data._id;
          this.router.routeReuseStrategy.shouldReuseRoute = () => false;
          this.router.onSameUrlNavigation = 'reload';
          setTimeout(() => {
            this.router.navigate([currentUrl]);
          }, 200);
        }, 200);
      },
      err => {
      }
    )
  }
  closeThankyou() {
    this.showThankyouModal = false;
    this.showBalanceModal = true;
    //this.router.navigate(['/']);
    //this.router.navigate(['/my-wallet']);
  }
  addCoin() {
    this.addCoinModal = true;
    this.showBalanceModal = false;
  }
  onCoinSubmit() {
    this.coinSubmitted = true;
    if (this.addCoinForm.invalid) {
      return;
    }
    let addCoinData = this.addCoinForm.value;
    addCoinData['userId'] = this.userId;
    if (addCoinData['amount'] > 0) {
      this.addCoinModal = false;
      addCoinData = JSON.stringify(addCoinData, null, 4);
      this.walletPaymentService.addWalletPayment(addCoinData).subscribe(data => {
        let options: any = {
          key: environment.RAZORPAY_KEY_ID,
          amount: (this.addCoinForm.value.amount * 10) * 100, // amount should be in paise format to display Rs 1255 without decimal point
          currency: 'INR',
          name: 'TPL', // company name or product name
          description: 'User Added Coins to wallet',  // product description
          image: '../../../../assets/images/logo.png', // company logo or product image
          order_id: data.data['orderId'], // user_id created by you in backend
          modal: {
            // We should prevent closing of the form when esc key is pressed.
            escape: false,
          },
          notes: {
            // include notes if any
          },
          theme: {
            color: '#0c238a'
          }
        };
        options.handler = ((response, error) => {
          options.response = response;
          let verifyPaymentData = {
            'razorpay_payment_id': response.razorpay_payment_id,
            'razorpay_order_id': response.razorpay_order_id,
            'razorpay_signature': response.razorpay_signature,
            'userId': this.userId,
            'walletType': 'COINS',
            'amount': this.addCoinForm.value.amount
          };
          // call your backend api to verify payment signature & capture transaction
          this.walletPaymentService.verifyWalletpayment(verifyPaymentData).subscribe(paymentdata => {
            this.showThankyouModal = true;
            let currentUrl = this.router.url;
            this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
              this.router.navigate([currentUrl]);
            });
          })
        });
        options.modal.ondismiss = (() => {
          // handle the case when user closes the form while transaction is in progress
          console.log('Transaction cancelled.');
        });
        const rzp = new this.winRef.nativeWindow.Razorpay(options);
        rzp.open();
        return;
      });
    }
  }
  coinClose() {
    this.coinSubmitted = false;
  }
  onClickViewLeaderBoard(id) {
    this.router.navigateByUrl('/contest-leader-board/' + id);
  }
  onClickRejoin(userContestId) {
    window.localStorage.setItem('contest-details-thankyou-page-display',JSON.stringify(false));
    setTimeout(() => {
      let currentUrl = "/contest-details/" + userContestId;
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.router.onSameUrlNavigation = "reload";
      setTimeout(() => {
        this.router.navigate([currentUrl],{ queryParams: { contestJoin: false, tplCoins: false, resumeContest: true }});
      }, 200);
    }, 200);
    return;  
  }

  async loadContestForRejoin(event: LazyLoadEvent, mode) {
    this.lazyLoadEvent2 = event;
    const contestTabs = ['All Contest','Resume Contest'];
    let pagenumber = 1;
    let params = "";
    let rows = 10;
    let date = new Date();
    let query = "filterByDisable=false&filterByStatus=true&filterByisContestRegistrationComplete=false&filterByDateAndTime=" + moment(date).utc().format("YYYY-MM-DD") + "&filterByUserId=" + this.userId;
    if (event !== undefined && !this.onContestTabChange) {
      if (event.first != undefined && event.first == 0) {
        pagenumber = event.first + 1;
      } else if (event.first != undefined && event.first > 0) {
        pagenumber = (event.first / event.rows) + 1;
      } else {
        pagenumber = 1;
      }
      if (event.rows != undefined) {  
        rows = event.rows;
      } else {
        rows = 10;
      }
      if(contestTabs[this.activeIndex] === 'Resume Contest') {
        let contestHistoryPaginationValues = { page: pagenumber, limit: rows, tab: this.activeIndex }
        window.localStorage.setItem('my-contest-pagination',JSON.stringify(contestHistoryPaginationValues));
      }
    }

    if(event === undefined || contestTabs[this.activeIndex] !== 'Resume Contest') {
      const paginationData = JSON.parse(window.localStorage.getItem('my-contest-pagination'));
      pagenumber = paginationData['page'];
      rows = paginationData['limit'];
      this.activeIndex = paginationData['tab'];
    }
    this.pageNumberFirst = pagenumber;
    this.pageLimitFirst = rows;
    
    query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
    this.userContestService.getUserContestList(query).subscribe(
      data => {
        this.loading = false;
        this.rejoincontestList = data.data.items;
        const filteredItems = data?.data?.items?.filter(item => item.matchStatus !== "inprogress" && item.matchStatus !== "finished");
        this.rejoincontestList = filteredItems;
        //let counter = 100;
        this.rejoincontestList?.forEach(cElement => {
          let tournamentstr = cElement.tournamentName;          
          if(cElement.tournamentName != undefined){
            let tournamentarr = tournamentstr.split(",");
            if(tournamentarr.length > 0) {
              cElement.displaytournamentName = tournamentarr[0];
            } else {
              cElement.displaytournamentName = tournamentstr;
            }
          } else {
            cElement.displaytournamentName = tournamentstr;
          }

          let startTime = moment(new Date());
          let end = moment(cElement.matchDate);
          let duration = moment.duration(end.diff(startTime));
          let hours = duration.asHours();
          let counter = Number(hours) * Number(3600);
          cElement['time'] = counter;
          // minute = Math.round(minute);
          cElement['timerInterval'] = setInterval(() => {
            let seconds = cElement['time'];
            let dayTime = (60 * 60 * 24);
            let day = Math.floor(seconds / dayTime);
            let remainingTime = (seconds - (dayTime * day));
            let hoursTime = (60 * 60);
            let hour = Math.floor(remainingTime / (hoursTime))
            remainingTime = (remainingTime - (hoursTime * hour));
            let minTime = 60;
            let minute = Math.floor(remainingTime / minTime)
            remainingTime = (remainingTime - (minTime * minute));
            let second = Math.floor(remainingTime)
            cElement['time']--;
            if (day >= 0) {
              if (day >= 2 && hour >= 0 && minute >= 0 && second >= 0) {
                cElement['displayTime'] = day + ' Days';
              } else if (day > 0 && hour >= 0 && minute >= 0 && second >= 0) {
                cElement['displayTime'] = day + ' Days ' + hour + ' Hours';
              } else if (day <= 0 && hour > 0 && minute >= 0 && second >= 0) {
                cElement['displayTime'] = hour + ' : ' + minute + ' : ' + second + ' Hrs';
              } else if (day <= 0 && hour == 0 && minute > 0 && second >= 0) {
                cElement['displayTime'] = minute + ' : ' + second + ' Minutes';
              } else if (day <= 0 && hour == 0 && minute == 0 && second > 0) {
                cElement['displayTime'] = second + ' Seconds left';
              } else if (day <= 0 && hour === 0 && minute == 0 && second == 0) {
                cElement['displayTime'] = 'Match Started';
              }
            }
            this.changeDetectorRef.detectChanges();
          }, 1000);
          // counter = 200;
        });
        this.totalRecordsForRejoin = data.data.totalCount;
      },
      err => {
        this.errorMessage = err.error.message;
      });
  }

  onTabChange(event: any) {
    this.onContestTabChange = true;
    this.activeIndex = event.index; // Update activeTab to reflect the selected tab
    this.pageNumberFirst = 1;
    this.pageLimitFirst = 10;
    let contestHistoryPaginationValues = { page: 1, limit: 10, tab: event.index }
    window.localStorage.setItem('my-contest-pagination',JSON.stringify(contestHistoryPaginationValues));
    const contestTabs = ['All Contest','Resume Contest'];
    setTimeout(()=>{
      if(contestTabs[this.activeIndex] === 'All Contest') {
        this.loadContest(this.lazyLoadEvent1, this.mode);
      } else {
        this.loadContestForRejoin(this.lazyLoadEvent2,this.mode);
      }
    },0);
  }
  // showPrizePoolStructure(contest) {
  //   this.pricePoolStructurePopup = true;
  //   if (contest.totalEntries >= 2 && contest.totalEntries <= 4) {
  //     this.twoToFour = true;
  //     this.fiveToSeven = false;
  //     this.sevenToTen = false;
  //     this.eightToTwelve = false;
  //     this.thirteenToEighteen = false;
  //     this.nineteenToTwentySeven = false;
  //     this.twentyEightToThirtySix = false;
  //     this.thirtySevenToFifty = false;
  //     this.fiftyOnePlus = false;
  //   }
  //   if (contest.totalEntries >= 5 && contest.totalEntries <= 7) {
  //     this.fiveToSeven = true;
  //     this.twoToFour = false;
  //     this.sevenToTen = false;
  //     this.eightToTwelve = false;
  //     this.thirteenToEighteen = false;
  //     this.nineteenToTwentySeven = false;
  //     this.twentyEightToThirtySix = false;
  //     this.thirtySevenToFifty = false;
  //     this.fiftyOnePlus = false;
  //   }
  //   if (contest.totalEntries >= 7 && contest.totalEntries <= 10) {
  //     this.sevenToTen = true;
  //     this.fiveToSeven = false;
  //     this.twoToFour = false;
  //     this.eightToTwelve = false;
  //     this.thirteenToEighteen = false;
  //     this.nineteenToTwentySeven = false;
  //     this.twentyEightToThirtySix = false;
  //     this.thirtySevenToFifty = false;
  //     this.fiftyOnePlus = false;
  //   }
  //   if (contest.totalEntries >= 8 && contest.totalEntries <= 12) {
  //     this.eightToTwelve = true;
  //     this.sevenToTen = false;
  //     this.fiveToSeven = false;
  //     this.twoToFour = false;
  //     this.thirteenToEighteen = false;
  //     this.nineteenToTwentySeven = false;
  //     this.twentyEightToThirtySix = false;
  //     this.thirtySevenToFifty = false;
  //     this.fiftyOnePlus = false;
  //   }
  //   if (contest.totalEntries >= 13 && contest.totalEntries <= 18) {
  //     this.thirteenToEighteen = true;
  //     this.eightToTwelve = false;
  //     this.sevenToTen = false;
  //     this.fiveToSeven = false;
  //     this.twoToFour = false;
  //     this.nineteenToTwentySeven = false;
  //     this.twentyEightToThirtySix = false;
  //     this.thirtySevenToFifty = false;
  //     this.fiftyOnePlus = false;
  //   }
  //   if (contest.totalEntries >= 19 && contest.totalEntries <= 27) {
  //     this.nineteenToTwentySeven = true;
  //     this.thirteenToEighteen = false;
  //     this.eightToTwelve = false;
  //     this.sevenToTen = false;
  //     this.fiveToSeven = false;
  //     this.twoToFour = false;
  //     this.twentyEightToThirtySix = false;
  //     this.thirtySevenToFifty = false;
  //     this.fiftyOnePlus = false;
  //   }
  //   if (contest.totalEntries >= 28 && contest.totalEntries <= 36) {
  //     this.twentyEightToThirtySix = true;
  //     this.nineteenToTwentySeven = false;
  //     this.thirteenToEighteen = false;
  //     this.eightToTwelve = false;
  //     this.sevenToTen = false;
  //     this.fiveToSeven = false;
  //     this.twoToFour = false;
  //     this.thirtySevenToFifty = false;
  //     this.fiftyOnePlus = false;
  //   }
  //   if (contest.totalEntries >= 37 && contest.totalEntries <= 50) {
  //     this.thirtySevenToFifty = true;
  //     this.twentyEightToThirtySix = false;
  //     this.nineteenToTwentySeven = false;
  //     this.thirteenToEighteen = false;
  //     this.eightToTwelve = false;
  //     this.sevenToTen = false;
  //     this.fiveToSeven = false;
  //     this.twoToFour = false;
  //     this.fiftyOnePlus = false;
  //   }
  //   if (contest.totalEntries >= 51) {
  //     this.fiftyOnePlus = true;
  //     this.thirtySevenToFifty = false;
  //     this.twentyEightToThirtySix = false;
  //     this.nineteenToTwentySeven = false;
  //     this.thirteenToEighteen = false;
  //     this.eightToTwelve = false;
  //     this.sevenToTen = false;
  //     this.fiveToSeven = false;
  //     this.twoToFour = false;
  //   }
  // }

  showPrizePoolNewstructure(contest) {
    this.pricePoolStructurePopup = true;
    if (contest.totalEntries >= 0 && contest.totalEntries <= 4) {
      this.twoToFour = true;
      this.fiveToSeven = false;
      this.sevenToTen = false;
      this.eightToTen = false;
      this.elevenToThirteen = false;
      this.fourteenToEighteen = false;
      this.nineteenToTwentySeven = false;
      this.twentyEightToThirtySix = false;
      this.thirtySevenToFifty = false;
      this.fiftyOnePlus = false;
    }
    if (contest.totalEntries >= 5 && contest.totalEntries <= 7) {
      this.fiveToSeven = true;
      this.twoToFour = false;
      this.sevenToTen = false;
      this.eightToTen = false;
      this.elevenToThirteen = false;
      this.fourteenToEighteen = false;
      this.nineteenToTwentySeven = false;
      this.twentyEightToThirtySix = false;
      this.thirtySevenToFifty = false;
      this.fiftyOnePlus = false;
    }
    if (contest.totalEntries >= 8 && contest.totalEntries <= 10) {
      this.eightToTen = true;
      this.fiveToSeven = false;
      this.twoToFour = false;
      this.sevenToTen = false;
      this.elevenToThirteen = false;
      this.fourteenToEighteen = false;
      this.nineteenToTwentySeven = false;
      this.twentyEightToThirtySix = false;
      this.thirtySevenToFifty = false;
      this.fiftyOnePlus = false;
    }
    if (contest.totalEntries >= 11 && contest.totalEntries <= 13) {
      this.elevenToThirteen = true;
      this.eightToTen = false;
      this.fiveToSeven = false;
      this.twoToFour = false;
      this.sevenToTen = false;
      this.fourteenToEighteen = false;
      this.nineteenToTwentySeven = false;
      this.twentyEightToThirtySix = false;
      this.thirtySevenToFifty = false;
      this.fiftyOnePlus = false;
    }
    if (contest.totalEntries >= 14 && contest.totalEntries <= 18) {
      this.fourteenToEighteen = true;
      this.elevenToThirteen = false;
      this.eightToTen = false;
      this.fiveToSeven = false;
      this.twoToFour = false;
      this.sevenToTen = false;
      this.nineteenToTwentySeven = false;
      this.twentyEightToThirtySix = false;
      this.thirtySevenToFifty = false;
      this.fiftyOnePlus = false;
    }
    if (contest.totalEntries >= 19 && contest.totalEntries <= 27) {
      this.nineteenToTwentySeven = true;
      this.fourteenToEighteen = false;
      this.elevenToThirteen = false;
      this.eightToTen = false;
      this.fiveToSeven = false;
      this.twoToFour = false;
      this.sevenToTen = false;
      this.twentyEightToThirtySix = false;
      this.thirtySevenToFifty = false;
      this.fiftyOnePlus = false;
    }
    if (contest.totalEntries >= 28 && contest.totalEntries <= 36) {
      this.twentyEightToThirtySix = true;
      this.nineteenToTwentySeven = false;
      this.fourteenToEighteen = false;
      this.elevenToThirteen = false;
      this.eightToTen = false;
      this.fiveToSeven = false;
      this.twoToFour = false;
      this.sevenToTen = false;
      this.thirtySevenToFifty = false;
      this.fiftyOnePlus = false;
    }
    if (contest.totalEntries >= 37 && contest.totalEntries <= 50) {
      this.thirtySevenToFifty = true;
      this.twentyEightToThirtySix = false;
      this.nineteenToTwentySeven = false;
      this.fourteenToEighteen = false;
      this.elevenToThirteen = false;
      this.eightToTen = false;
      this.fiveToSeven = false;
      this.twoToFour = false;
      this.sevenToTen = false;
      this.fiftyOnePlus = false;
    }
    if (contest.totalEntries >= 51) {
      this.fiftyOnePlus = true;
      this.thirtySevenToFifty = false;
      this.twentyEightToThirtySix = false;
      this.nineteenToTwentySeven = false;
      this.fourteenToEighteen = false;
      this.elevenToThirteen = false;
      this.eightToTen = false;
      this.fiveToSeven = false;
      this.twoToFour = false;
      this.sevenToTen = false;
    }
  }
}
